import { yupResolver } from '@hookform/resolvers/yup';
import { TabPanel, TabView } from 'primereact/tabview';
import { useEffect, useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  FormDataFranchise,
  FranchiseType,
} from '../../../../../types/api/franchises';
import {
  getInitialValues,
  getValidationSchema,
  tabIcon,
} from './CreateEditDialog.functions';
import Allowances from './Tabs/Allowances';
import GeneralInfo from './Tabs/GeneralInfo';

type Props = {
  data: FranchiseType | undefined;
  isEditDialog: boolean;
  handleSubmitForm: (data: FormDataFranchise) => void;
};

function FormContainer({ data, isEditDialog, handleSubmitForm }: Props) {
  const { t } = useTranslation();
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const validationSchema = useMemo(() => getValidationSchema(t), [t]);

  const defaultValues = useMemo(
    () => getInitialValues(data, isEditDialog),
    [data, isEditDialog]
  );

  const methods = useForm<FormDataFranchise>({
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { errors },
  } = methods;
  console.log('errors', errors);
  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const generalInfoTabIcon = tabIcon('general-info', errors);
  const allowancesTabIcon = tabIcon('allowances', errors);

  return (
    <FormProvider {...methods}>
      <form
        id="franchise-create-edit-form"
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <TabView
          activeIndex={activeTabIndex}
          onTabChange={(e) => setActiveTabIndex(e.index)}
          className={Object.keys(errors).length > 0 ? 'invalid' : ''}
        >
          <TabPanel header={t('General info')} {...generalInfoTabIcon}>
            <GeneralInfo />
          </TabPanel>

          <TabPanel header={t('Allowances')} {...allowancesTabIcon}>
            <Allowances />
          </TabPanel>
        </TabView>
      </form>
    </FormProvider>
  );
}

export default FormContainer;
